export default [
  {
    id: "tagCategory",
    name: "Tag category",
  },
  {
    id: "formattedDate",
    name: "Date",
  },
  {
    id: "percentTagged",
    name: " % Tagged",
    numeric: true,
  },
  {
    id: "percentUntaggedEquities",
    name: " % Untagged equities",
    numeric: true,
  },
  {
    id: "untaggedSecurities",
    name: "Untagged securities",
    numeric: true,
  },
]
